import type { IconProps } from './types';

export const Minimize = ({ size, ...props }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.33333 10.6667H7.33333M7.33333 10.6667V15.6667M7.33333 10.6667L1.5 16.5M15.6667 7.33333H10.6667M10.6667 7.33333V2.33333M10.6667 7.33333L16.5 1.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
